export function navigationDropdowns(elements) {
    if (!elements) return;

    const dropdownToggles = elements instanceof NodeList ? Array.from(elements) : [elements];
    const siteBody = document.querySelector('body');
    const siteHeader = document.querySelector('[data-js="site-header"]');

    const DESKTOP_BREAKPOINT = 1080;
    const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

    let closeTimeout = null;

    function closeDropdowns() {
        siteBody.classList.remove('site-nav-visible');

        dropdownToggles.forEach((btn) => {
            const panel = document.getElementById(btn.getAttribute('aria-controls'));

            if (btn.getAttribute('aria-expanded') === 'true') {
                btn.setAttribute('aria-expanded', 'false');
                btn.classList.remove('is-active');
                btn.removeAttribute('data-opened-by');

                if (panel) {
                    panel.classList.remove('is-visible');
                }
            }
        });
    }

    function openDropdown(toggleBtn, openedBy) {
        const panel = document.getElementById(toggleBtn.getAttribute('aria-controls'));

        closeDropdowns();

        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.classList.add('is-active');
        toggleBtn.setAttribute('data-opened-by', openedBy);

        siteBody.classList.add('site-nav-visible');

        if (panel) {
            panel.classList.add('is-visible');
        }
    }

    function handleToggle(e) {
        e.preventDefault();

        const toggleBtn = e.currentTarget;
        const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            closeDropdowns();
        } else {
            openDropdown(toggleBtn, 'click');
        }
    }

    // -----------------------------
    // Button interactions
    // -----------------------------
    dropdownToggles.forEach((btn) => {
        const navItem = btn.closest('.has-dropdown');

        // Click / keyboard (unchanged)
        btn.addEventListener('click', handleToggle);

        // Hover switching (desktop only)
        if (navItem) {
            navItem.addEventListener('mouseenter', () => {
                if (!isDesktop()) return;
                openDropdown(btn, 'hover');
            });
        }
    });

    // -----------------------------
    // Header-level hover boundary
    // -----------------------------
    if (siteHeader) {
        siteHeader.addEventListener('mouseenter', () => {
            clearTimeout(closeTimeout);
        });

        siteHeader.addEventListener('mouseleave', () => {
            if (!isDesktop()) return;

            closeTimeout = setTimeout(() => {
                closeDropdowns();
            }, 150);
        });
    }

    // -----------------------------
    // Escape key support (recommended)
    // -----------------------------
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeDropdowns();
        }
    });
}
